const services = [
  {
    icon: 'ri-code-s-slash-line',
    title: 'Développement logiciel',
    description:
      'Création de solutions sur mesure adaptées aux besoins spécifiques de votre entreprise. Applications robustes, sécurisées et évolutives.',
  },
  {
    icon: 'ri-global-line',
    title: 'Développement web',
    description:
      'Conception de sites et applications web modernes et performants. Interfaces intuitives et expériences utilisateur optimisées.',
  },
  {
    icon: 'ri-tools-line',
    title: 'Maintenance et support',
    description:
      'Suivi technique et assistance des solutions mises en place. Disponibilité et réactivité pour assurer la continuité de vos services.',
  },
];

export default function ServicesSection() {
  return (
    <section id="services" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-xs font-semibold uppercase tracking-widest text-gray-400 mb-4">Nos services</p>
          <h2 className="font-heading font-bold text-navy-900 text-3xl md:text-4xl leading-tight">
            Solutions techniques<br />pour votre entreprise
          </h2>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {services.map((service) => (
            <article
              key={service.title}
              className="group bg-gray-50 rounded-xl p-8 md:p-10 hover:bg-navy-900 transition-all duration-300 cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-6">
                <i className={`${service.icon} text-3xl text-navy-900 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="font-heading font-semibold text-navy-900 group-hover:text-white text-xl mb-4 transition-colors duration-300">
                {service.title}
              </h3>
              <p className="text-gray-500 group-hover:text-white/70 text-sm leading-relaxed transition-colors duration-300">
                {service.description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
